import React from 'react';

const PodFilesTableComponentLoadable = React.lazy(() => import('./PodFilesTableComponent'));

export {
    PodFilesTableComponentLoadable
};
